export default __webpack_public_path__ + "static/media/ivrkstterprisen_3.c73dc636.png";